import template from './user-basic-details.html';
import userBasicDetailsController from './user-basic-details.controller';
import './user-basic-details.styl';

let userBasicDetailsComponent = {
  restrict: 'E',
  bindings: {
    user: '=',
  },
  template,
  controller: userBasicDetailsController,
  controllerAs: 'vm'
};

export default userBasicDetailsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-basic-details/user-basic-details.component.js
 **/